import { ChambersIndexColorEnum } from './ChambersIndexColorEnum';

export const calculateChamberIndexColor = (initValue: number, spentValue: number): ChambersIndexColorEnum => {
    const fillPercent = 1 - spentValue / initValue;

    const left = initValue - spentValue;

    if (fillPercent >= 0.75) {
        return ChambersIndexColorEnum.GREEN;
    }

    if (fillPercent < 0.75 && fillPercent >= 0.5) {
        return ChambersIndexColorEnum.YELLOW;
    }

    if (left >= 5 && fillPercent < 0.5) {
        return ChambersIndexColorEnum.ORANGE;
    }

    return ChambersIndexColorEnum.RED;
};
